// src/api.js
const API_BASE = "/api";

export function setToken(token) {
  localStorage.setItem("token", token);
}

export function getToken() {
  return localStorage.getItem("token");
}

export async function apiFetch(endpoint, options = {}) {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };
  const res = await fetch(API_BASE + endpoint, { ...options, headers });
  if (res.status === 401) {
    setToken("");
    window.location.reload();
  }
  return res.json();
}
